import {IconButton, ListItemIcon, Menu, MenuItem} from "@mui/material";
import {useAuth} from "../auth/AuthProvider";
import {AccountCircle, Help, Logout, Menu as MenuIcon} from "@mui/icons-material";
import {useState} from "react";
import {useLocation, useNavigate} from "react-router";

const HeaderMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const {signOut} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const isMenuOpen = Boolean(anchorEl);

    const handleLogout = () => {
        signOut();
    };

    const isPayLevelsPage = location.pathname === "/levels";
    const isPayAwardsPage = location.pathname === "/awards";

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const closeMenuAndNavigate = (path) => {
        handleMenuClose();
        navigate(path);
    };

    const HeaderMenuItem = ({label, path, icon}) => {
        return (
            <MenuItem onClick={() => closeMenuAndNavigate(path)}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                {label}
            </MenuItem>
        );
    };

    return (
        <>
            <IconButton
                onClick={handleMenuOpen}
                size="small"
                sx={{ml: 2}}
                aria-controls={isMenuOpen ? 'header-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? 'true' : undefined}
            >
                <MenuIcon sx={{width: 32, height: 32}}/>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                id="header-menu"
                open={isMenuOpen}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                <HeaderMenuItem label="My Details" path="/my_details" icon={<AccountCircle fontSize="small"/>}/>

                {isPayLevelsPage && (
                    <HeaderMenuItem label="Glossary" path="/help/levels" icon={<Help fontSize="small"/>}/>
                )}

                {isPayAwardsPage && (
                    <HeaderMenuItem label="Glossary" path="/help/awards" icon={<Help fontSize="small"/>}/>
                )}

                {!isPayLevelsPage && !isPayAwardsPage && (
                    <HeaderMenuItem label="Help" path="/help" icon={<Help fontSize="small"/>}/>
                )}

                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small"/>
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </>
    );
};

export default HeaderMenu;
